import { LessonBanner } from '@yandex-int/k-common/typings';
import b from 'b_';
import { BackgroundImage } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';

import { LessonViewStore } from 'common.components/lesson-view.store/interfaces';
import * as lessonSelectors from 'common.components/lesson/selectors';

import './lesson-view__banner.scss';

interface StoreProps {
    lessonBanner: LessonBanner;
}

interface Props extends StoreProps {}

const Banner = ({ lessonBanner }: Props) => {
    return (
        <div className="lesson-view__banner-wrapper">
            {lessonBanner.background_img ? (
                lessonBanner.background_img.map((img: string, index: number) => (
                    <div
                        className={b('lesson-view', 'banner', { density: `${index + 1}x` })}
                        style={{ backgroundColor: lessonBanner.background_color }}
                    >
                        <BackgroundImage objectFit="none" objectPosition="top left" src={img} />
                    </div>
                ))
            ) : (
                <div className="lesson-view__banner" style={{ backgroundColor: lessonBanner.background_color }} />
            )}
        </div>
    );
};

const mapStateToProps = <T extends LessonViewStore>(storeState: T): StoreProps => ({
    lessonBanner: lessonSelectors.getLessonBanner(storeState),
});

export default connect(mapStateToProps)(Banner);
